import React from 'react';

import { Pressable } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { useIsDesktopBreakpoint } from 'hooks/use-media-query';
import { getDesignToken, primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  container: {
    backgroundColor: getDesignToken('background-card'),
    borderRadius: primitive.$borderRadius,
    marginVertical: spacing.$4,
    padding: spacing.$4,
  },
  containerDesktop: {
    padding: spacing.$6,
  },
});

export const Container = ({ style, ...props }: BoxProps) => {
  const isDesktop = useIsDesktopBreakpoint();

  return React.createElement(Box, {
    ...props,
    style: [styles.container, isDesktop && styles.containerDesktop, style],
  });
};

export const DescriptionContainer = Pressable.withConfig({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
});
